import React from 'react'
import {
  ApolloClient,
  InMemoryCache,
  defaultDataIdFromObject,
  ApolloLink,
  HttpLink,
  ApolloProvider as ActualApolloProvider
} from '@apollo/client'
import { onError } from '@apollo/client/link/error'
import { setContext } from '@apollo/client/link/context'
import { getLocalToken } from 'react-u5auth'

export const apolloClient = new ApolloClient({
  link: ApolloLink.from([
    onError(({ graphQLErrors, networkError }) => {
      if (graphQLErrors) {
        graphQLErrors.forEach(({ message, locations, path }) =>
          console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
        )
      }
      if (networkError) console.log(`[Network error]: ${networkError}`)
    }),
    setContext((_, { headers }) => {
      const token = getLocalToken()
      return {
        headers: {
          ...headers,
          Authorization: token ? `Bearer ${token}` : ''
        }
      }
    }),
    new HttpLink({
      uri: `${process.env.REACT_APP_API_URL}/graphql`,
      credentials: 'same-origin'
    })
  ]),
  cache: new InMemoryCache({
    dataIdFromObject: object => {
      switch (object.__typename) {
        // case 'Something':
        //   return `${object.__typename}:${object.code}`
        default:
          return defaultDataIdFromObject(object)
      }
    }
  })
})

export const ApolloProvider = ({ children }) => (
  <ActualApolloProvider client={apolloClient}>
    {children}
  </ActualApolloProvider>
)
